import React, { useEffect, useState } from "react";
import { Container } from "shards-react";
import { NavLink as RouteNavLink } from "react-router-dom";
import {
  Button,
  Modal,
  Box,
  Typography,
  Input,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Select,
  MenuItem,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  FormControl,
  OutlinedInput,
  CircularProgress,
  FormControlLabel,
  InputLabel,
  TextField,
  Switch,
  Link
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import RestoreIcon from "@mui/icons-material/Restore";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import * as XLSX from "xlsx/xlsx.js";
import { auth_reading_stage, db, db_reading_stage } from "../../firebase";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import "./students.styles.css";
import Pagination from "@mui/material/Pagination/Pagination";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where
} from "firebase/firestore";
import moment from "moment";
import { Cloud_API_URL, adminUrls } from "../../utils/constants";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { getTeacherInfoForStudent } from "../../utils/api_calls";

const Students = () => {
  const [open, setOpen] = useState(false);
  const [dataOpen, setDataOpen] = useState(false);
  const [teacherModalOpen, setTeacherModalOpen] = useState(false);
  const [teacherIndex, setTeacherIndex] = useState(null);
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [schools, setSchools] = useState([]);
  const [classes, setClasses] = useState({}); // Store classes by school id
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bulkEditVisible, setBulkEditVisible] = useState(false);
  const [bulkEditEnabled, setBulkEditEnabled] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [importedStudents, setImportedStudents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [filterSchool, setFilterSchool] = useState("");
  const [filterClass, setFilterClass] = useState("");
  const [filterTeachers, setFilterTeachers] = useState([]);
  const [selectedTeacherUserIds, setSelectedTeacherUserIds] = useState([]);
  const [teacherFilterModalOpen, setTeacherFilterModalOpen] = useState(false);
  const [studentModalOpen, setStudentModalOpen] = useState(false);
  const [isSingleStudent, setIsSingleStudent] = useState(false);
  const [editingStudent, setEditingStudent] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [studentForm, setStudentForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    birthdate: "",
    school: "",
    class: "",
    teachers: []
  });
  const [
    studentTeacherDataModalOpen,
    setStudentTeacherDataModalOpen
  ] = useState(false);
  const [selectedStudentTeachers, setSelectedStudentTeachers] = useState([]);
  const [selectedStudentName, setSelectedStudentName] = useState("");
  const [filterValidTill, setFilterValidTill] = useState(true);
  const handleValidTillToggle = () => {
    setFilterValidTill(prev => !prev);
  };
  const reportFrequencies = [
    { value: 0, label: "Never" },
    { value: 1, label: "Daily" },
    { value: 2, label: "Weekly" },
    { value: 3, label: "Monthly" }
  ];

  const [reportFrequency, setReportFrequency] = useState(0);
  const [openReportFrequencyModal, setOpenReportFrequencyModal] = useState(
    false
  );

  const { currentUser, userRole } = useAuth();
  const history = useHistory();
  const trackStudentsUrl = `/sub-admin-students-tracking/${currentUser.uid}/${currentUser.displayName}`;
  const [teacherSearchTerm, setTeacherSearchTerm] = useState("");

  const filteredTeachers = teachers.filter(teacher =>
    teacher.name.toLowerCase().includes(teacherSearchTerm.toLowerCase())
  );
  const handleShowDetails = userId => {
    history.push(`/user-details/${userId}`);
  };

  const handleOpenStudentModal = (student = null) => {
    setEditingStudent(student);
    if (student) {
      // Pre-fill the form with existing student data for editing
      setStudentForm({
        first_name: student.first_name || "",
        last_name: student.last_name || "",
        email: student.email || "",
        birthdate: student.birthdate || "",
        school: student.class.school.id || "",
        class: student.class.id || "",
        teachers: student.studentTeachers || []
      });
    } else {
      // Reset the form for a new student
      setStudentForm({
        first_name: "",
        last_name: "",
        email: "",
        birthdate: "",
        school: "",
        class: "",
        teachers: []
      });
    }
    setStudentModalOpen(true);
  };

  const handleCloseStudentModal = () => setStudentModalOpen(false);
  const handleDateChange = newValue => {
    setSelectedDate(newValue);
  };
  const handleFormChange = (field, value) => {
    setStudentForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveStudent = async () => {
    const {
      first_name,
      last_name,
      email,
      birthdate,
      school,
      class: classId,
      teachers
    } = studentForm;

    if (!first_name || !last_name || !email) {
      alert("First name, last name, and email are required.");
      return;
    }

    // If birthdate is not set, use today's date
    const formattedBirthdate =
      birthdate || new Date().toISOString().split("T")[0];

    const teacherIds = teachers.map(teacher => {
      return typeof teacher === "object"
        ? teacher.teacherId || teacher.id
        : teacher;
    });

    const studentData = {
      first_name,
      last_name,
      email,
      birthdate: formattedBirthdate,
      schoolId: school,
      classId,
      teacherIds
    };

    try {
      if (editingStudent) {
        // Update existing student
        await axios.put(
          `${Cloud_API_URL}/school/student/${editingStudent.id}`,
          studentData
        );
      } else {
        // Create new student
        await axios.post(`${Cloud_API_URL}/school/student`, studentData);
      }
      fetchStudents(); // Refresh the student list
      handleCloseStudentModal(); // Close the modal
    } catch (error) {
      console.error("Error saving student:", error);
      alert("An error occurred while saving the student. Please try again.");
    }
  };

  const handleTeacherFilterModalOpen = () => setTeacherFilterModalOpen(true);
  const handleTeacherFilterModalClose = () => {
    setTeacherSearchTerm("");
    setTeacherFilterModalOpen(false);
  };

  const handleTeacherFilterChange = teacherId => {
    const newFilterTeachers = [...filterTeachers];
    const index = newFilterTeachers.indexOf(teacherId);

    if (index > -1) {
      newFilterTeachers.splice(index, 1);
    } else {
      newFilterTeachers.push(teacherId);
    }

    setFilterTeachers(newFilterTeachers);
    setPage(1); // Reset to first page when filter changes
  };

  const fetchStudents = async (
    page = 1,
    filterSchool,
    filterClass,
    filterTeachers,
    fetchAll = false
  ) => {
    try {
      setLoading(true);
      const teacherFilters =
        filterTeachers && Array.isArray(filterTeachers) ? filterTeachers : [];

      let allStudents = [];
      let currentPage = page;
      let totalFetched = 0;
      let totalCount = 0;
      const take = 50;

      do {
        const params = {
          page: currentPage,
          take,
          schoolId: filterSchool || undefined,
          classId: filterClass || undefined,
          teacherIds: teacherFilters.length > 0 ? filterTeachers.join(",") : [],
          teacher_uuid: currentUser.uid,
          isAdmin: userRole === "admin"
        };

        const response = await axios.get(`${Cloud_API_URL}/school/students`, {
          params
        });
        const studentsData = response.data.students;
        allStudents = [...allStudents, ...studentsData];
        totalFetched += studentsData.length;
        totalCount = response.data.totalCount;
        currentPage++;
      } while (fetchAll && totalFetched < totalCount);

      // Fetch ValidTill field from Firebase for each student
      const studentsWithValidTill = await Promise.all(
        allStudents.map(async student => {
          if (student.user && student.user.uuid) {
            const studentDocRef = doc(db, "UserData", student.user.uuid);
            const studentDoc = await getDoc(studentDocRef);
            if (studentDoc.exists) {
              let firebaseData = studentDoc.data();
              if (firebaseData && firebaseData.ValidTill) {
                const validTillDate = new Date(
                  firebaseData.ValidTill.seconds * 1000 +
                    firebaseData.ValidTill.nanoseconds / 1e6
                );

                student.isValid = new Date() < validTillDate;
                student.validTill = validTillDate;
              } else {
                student.isValid = false;
                student.validTill = null;
              }
            } else {
              student.isValid = false;
              student.validTill = null;
            }
          } else {
            student.isValid = false;
            student.validTill = null;
          }

          return student;
        })
      );
      setStudents(studentsWithValidTill);

      setTotalCount(fetchAll ? studentsWithValidTill.length : totalCount);
    } catch (error) {
      console.error("There was an error fetching the students!", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch students whenever filters or page changes
  useEffect(() => {
    fetchStudents(
      page,
      filterSchool,
      filterClass,
      filterTeachers,
      filterValidTill
    );
  }, [page, filterSchool, filterClass, filterTeachers, filterValidTill]);

  // Handle filtering of valid students
  useEffect(() => {
    if (filterValidTill) {
      const now = new Date();
      const filtered = students.filter(
        student =>
          (!student.validTill && !student.user) ||
          (student.validTill && new Date(student.validTill) > now)
      );

      setFilteredStudents(filtered);

      // If filter is ON, show all valid users on one page
      setTotalCount(filtered.length);
      setPage(1); // Reset to first page when switching filter ON
    } else {
      setFilteredStudents(students);

      // If filter is OFF, use response.data.totalCount
      //  setTotalCount(totalCount);
    }
  }, [students, filterValidTill]);

  const handleReportFrequencyChange = async event => {
    let selectedFrequency = event.target.value;

    setReportFrequency(selectedFrequency);

    let params = {
      frequency: selectedFrequency
    };

    const response = await axios.post(
      `${Cloud_API_URL}/school/teacher/reports-frequency/${currentUser.uid}`,
      params
    );
  };

  const handleSchoolFilterChange = event => {
    setFilterSchool(event.target.value);
    setPage(1); // Reset to first page when filter changes
  };

  const handleClassFilterChange = event => {
    setFilterClass(event.target.value);
    setPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(async () => {
    // get report frequency for the logged in teacher
    const getReportFrequency = async () => {
      const response = await axios.get(
        `${Cloud_API_URL}/school/teacher/reports-frequency/${currentUser.uid}`
      );

      return response.data.frequency;
    };

    if (
      currentUser &&
      (userRole === "specialTeacher" ||
        userRole === "classTeacher" ||
        userRole === "principalTeacher" ||
        userRole === "teacher")
    ) {
      let reportFrequency = await getReportFrequency();

      setReportFrequency(reportFrequency);
    }
    // Fetch schools and teachers from the API
    axios
      .get(`${Cloud_API_URL}/school`)
      .then(response => {
        const { schools, teachers } = response.data;
        setSchools(schools);

        // Create a map of schoolId to classes
        const classesMap = schools.reduce((acc, school) => {
          acc[school.id] = school.classes;
          return acc;
        }, {});
        setClasses(classesMap);

        // Map teachers to include their full name and sort them alphabetically
        const teacherData = teachers
          .map(teacher => ({
            ...teacher,
            name: `${teacher.first_name || ""} ${teacher.last_name ||
              ""}`.trim(),
            userId: teacher.userId
          }))
          .sort((a, b) => a.name.localeCompare(b.name)); // Sort alphabetically by name

        setTeachers(teacherData);
      })
      .catch(error => {
        console.error("There was an error fetching the schools!", error);
      });
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleDataOpen = () => setDataOpen(true);
  const handleDataClose = () => {
    setBulkEditVisible(false);
    setBulkEditEnabled(false);
    setDataOpen(false);
  };
  const handleTeacherModalOpen = index => {
    setTeacherIndex(index);
    setTeacherModalOpen(true);
  };
  function parseExcelDate(dateString) {
    if (!isNaN(dateString)) {
      return excelDateToJSDate(parseFloat(dateString));
    }

    const possibleFormats = [
      "DD/MM/YYYY",
      "MM/DD/YYYY",
      "YYYY-MM-DD",
      "D/M/YY",
      "D/M/YYYY",
      "M/D/YYYY",
      "M/D/YY",
      "YYYY/MM/DD",
      "DD-MM-YYYY",
      "MM-DD-YYYY",
      "YYYY-MM-DD"
    ];

    const parsedDate = moment(dateString, possibleFormats, true);

    // Check if the date is valid
    if (parsedDate.isValid()) {
      return parsedDate.toDate();
    }

    // If the date is not valid, return null or handle the error as needed
    console.error(`Unable to parse date: ${dateString}`);
    return null;
  }

  function excelDateToJSDate(serial) {
    const utcDays = Math.floor(serial - 25569);
    const utcValue = utcDays * 86400;
    const dateInfo = new Date(utcValue * 1000);

    const fractionalDay = serial - Math.floor(serial) + 0.0000001;

    let totalSeconds = Math.floor(86400 * fractionalDay);

    const seconds = totalSeconds % 60;
    totalSeconds -= seconds;

    const hours = Math.floor(totalSeconds / (60 * 60));
    const minutes = Math.floor(totalSeconds / 60) % 60;

    return new Date(
      dateInfo.getFullYear(),
      dateInfo.getMonth(),
      dateInfo.getDate(),
      hours,
      minutes,
      seconds
    );
  }
  function isExcelDate(value) {
    return typeof value === "number" && value > 25569 && value < 2958465;
  }

  const handleTeacherModalClose = () => {
    setTeacherSearchTerm("");
    setTeacherModalOpen(false);
  };
  const handleStudentTeacherdataModalClose = () =>
    setStudentTeacherDataModalOpen(false);
  const handleFileUpload = async e => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = async event => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, {
        type: "array"
      });
      const sheetName = workbook.SheetNames[0];
      const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

      // Normalize column titles by trimming and removing extra spaces
      const normalizedWorksheet = worksheet.map(row => {
        const cleanedRow = {};
        Object.keys(row).forEach(key => {
          const normalizedKey = key
            .trim() // Trim leading/trailing spaces
            .replace(/\s+/g, " "); // Replace multiple spaces with a single space

          const value = row[key];
          // Assign cleaned key to the cleaned row, and trim the value if it's a string
          cleanedRow[normalizedKey] =
            typeof value === "string" ? value.trim() : value;
        });
        return cleanedRow;
      });

      const studentsWithTeachers = await Promise.all(
        normalizedWorksheet.map(async row => {
          const teacherEmails = [
            row["Special teacher"],
            row["Class teacher 1"],
            row["Class teacher 2"],
            row["Class teacher 3"],
            row["Principal"]
          ].filter(Boolean); // Remove undefined or empty values

          // Fetch corresponding Firestore documents
          const matchedTeachers = await Promise.all(
            teacherEmails.map(async email => {
              const q = query(
                collection(db, "SubAdminData"),
                where("Email", "==", email)
              );
              const querySnapshot = await getDocs(q);

              // If a matching document is found, get the Firestore document ID
              if (!querySnapshot.empty) {
                const matchedTeacher = querySnapshot.docs[0];
                return matchedTeacher.id; // Firestore document ID
              }
              return null; // Return null if no match is found
            })
          );

          const filteredMatchedTeachers = matchedTeachers.filter(Boolean); // Filter out null values

          let teacherSQLIds = [];

          // Only call the API if there are matched teachers
          if (filteredMatchedTeachers.length > 0) {
            // Construct the URL with query parameters
            const url = `${Cloud_API_URL}/school/teacher-ids?uuids=${filteredMatchedTeachers.join(
              ","
            )}`;

            // Call the API with the matched Firebase document IDs to get the SQL IDs
            const response = await axios.get(url);

            teacherSQLIds = response.data.map(teacher => teacher.id);
          }

          // Handle the date format
          let dayOfBirth = row["Day of birth"];
          if (isExcelDate(dayOfBirth)) {
            dayOfBirth = excelDateToJSDate(dayOfBirth);
          } else if (
            typeof dayOfBirth === "string" ||
            dayOfBirth instanceof Date
          ) {
            dayOfBirth = new Date(dayOfBirth);
          }

          if (isNaN(dayOfBirth)) {
            console.error(
              `Invalid birthdate for student ${row["Name"]} ${row["Surname"]}: ${row["Day of birth"]}`
            );
            dayOfBirth = undefined;
          } else {
            dayOfBirth = dayOfBirth.toISOString().split("T")[0];
          }

          // Auto-select school and class if they exist in the database
          const matchedSchool = schools.find(
            school => school.name.toLowerCase() === row["School"].toLowerCase() // Case-insensitive comparison
          );

          // Ensure that the class is treated as a string, even if it is a number in the Excel
          const classAsString = String(row["Class"]).trim();

          const matchedClass =
            matchedSchool && classes[matchedSchool.id]
              ? classes[matchedSchool.id].find(
                  schoolClass => schoolClass.name === classAsString
                )
              : null;

          const schoolId = matchedSchool ? matchedSchool.id : "";
          const classId = matchedClass ? matchedClass.id : "";

          return {
            ...row,
            teachers: teacherSQLIds,
            school: schoolId,
            class: classId,
            deleted: false,
            "Day of birth": dayOfBirth
          };
        })
      );

      setStudents(studentsWithTeachers);
      handleClose();
      handleDataOpen();
    };

    reader.readAsArrayBuffer(file);
  };

  const handleSchoolChange = index => event => {
    const schoolId = event.target.value;
    const newStudents = [...students];
    newStudents[index].school = schoolId;
    newStudents[index].class = ""; // Reset class when school changes
    setStudents(newStudents);
    checkBulkEditVisibility(index);
  };

  const handleDropdownChange = (index, field) => event => {
    const newStudents = [...students];
    newStudents[index][field] = event.target.value;
    setStudents(newStudents);
    checkBulkEditVisibility(index);
  };

  const handleTeacherSelection = teacherId => {
    const newStudents = [...students];
    const teacherList = newStudents[teacherIndex].teachers || [];
    const index = teacherList.indexOf(teacherId);

    if (index > -1) {
      teacherList.splice(index, 1);
    } else {
      teacherList.push(teacherId);
    }

    newStudents[teacherIndex].teachers = teacherList;
    setStudents(newStudents);
    checkBulkEditVisibility(teacherIndex);

    // Update the selectedTeacherUserIds state
    const selectedTeacher = teachers.find(teacher => teacher.id === teacherId);
    if (selectedTeacher) {
      const newSelectedTeacherUserIds = [...selectedTeacherUserIds];
      const userIdIndex = newSelectedTeacherUserIds.indexOf(
        selectedTeacher.userId
      );
      if (userIdIndex > -1) {
        newSelectedTeacherUserIds.splice(userIdIndex, 1);
      } else {
        newSelectedTeacherUserIds.push(selectedTeacher.userId);
      }
      setSelectedTeacherUserIds(newSelectedTeacherUserIds);
    }
  };
  const handleSingleStudentTeacherSelection = teacherId => {
    const teacherList = [...studentForm.teachers];

    const index = teacherList.findIndex(t =>
      typeof t === "number" ? t === teacherId : t.teacherId === teacherId
    );

    if (index > -1) {
      // If the teacher is already selected, remove it from the list
      teacherList.splice(index, 1);
    } else {
      // Otherwise, add the teacher ID to the list
      teacherList.push(teacherId);
    }

    // Update the form with the modified list
    setStudentForm(prevForm => ({
      ...prevForm,
      teachers: teacherList
    }));

    const selectedTeacher = teachers.find(teacher => teacher.id === teacherId);
    if (selectedTeacher) {
      const newSelectedTeacherUserIds = [...selectedTeacherUserIds];
      const userIdIndex = newSelectedTeacherUserIds.indexOf(
        selectedTeacher.userId
      );

      if (userIdIndex > -1) {
        newSelectedTeacherUserIds.splice(userIdIndex, 1);
      } else {
        newSelectedTeacherUserIds.push(selectedTeacher.userId);
      }
      setSelectedTeacherUserIds(newSelectedTeacherUserIds);
    }
  };

  const handleDeleteRow = index => {
    const newStudents = [...students];
    newStudents[index].deleted = true;
    setStudents(newStudents);
  };

  const handleRestoreRow = index => {
    const newStudents = [...students];
    newStudents[index].deleted = false;
    setStudents(newStudents);
  };

  const checkBulkEditVisibility = index => {
    const student = students[index];
    if (student.school && student.class && student.teachers.length > 0) {
      setSelectedRowIndex(index);
      setBulkEditVisible(true);
    } else {
      setBulkEditVisible(false);
      setBulkEditEnabled(false);
    }
  };

  const handleBulkEditChange = event => {
    const enabled = event.target.checked;
    setBulkEditEnabled(enabled);
    if (enabled && selectedRowIndex !== null) {
      const selectedStudent = students[selectedRowIndex];
      const updatedStudents = students.map(student => ({
        ...student,
        school: selectedStudent.school,
        class: selectedStudent.class,
        teachers: [...selectedStudent.teachers]
      }));
      setStudents(updatedStudents);
    }
  };

  const generateRandomPassword = () => {
    const length = 12;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  };

  const formatDateToIso = dateString => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleFinishImport = async () => {
    setLoading(true);

    const errors = [];
    const existingEmails = []; // Store emails that already exist
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple regex to validate email format

    const validStudents = students
      .filter(student => !student.deleted)
      .map((student, index) => {
        const {
          Name: first_name,
          Surname: last_name,
          Email: email,
          school,
          class: classId,
          teachers
        } = student;
        const rowIdentifier =
          first_name && last_name
            ? `${first_name} ${last_name}`
            : email
            ? email
            : `Row ${index + 1}`;

        // Check for missing required fields
        if (!first_name) {
          errors.push(`First name is missing for ${rowIdentifier}.`);
        }
        if (!last_name) {
          errors.push(`Last name is missing for ${rowIdentifier}.`);
        }
        if (!email) {
          errors.push(`Email is missing for ${rowIdentifier}.`);
        } else if (!emailRegex.test(email)) {
          // Check if the email is valid using the regex
          errors.push(`Invalid email format for ${rowIdentifier}: ${email}`);
        }
        if (!school) {
          errors.push(`School is not selected for ${rowIdentifier}.`);
        }
        if (!classId) {
          errors.push(`Class is not selected for ${rowIdentifier}.`);
        }
        if (!teachers || teachers.length === 0) {
          errors.push(`No teacher selected for ${rowIdentifier}.`);
        }

        return student;
      });

    if (errors.length > 0) {
      // Notify the user about the errors
      alert(`Please correct the following errors:\n${errors.join("\n")}`);
      setLoading(false);
      return;
    }

    try {
      const signupPromises = validStudents
        .filter(student => !student.deleted)
        .map(async student => {
          const {
            Name: first_name,
            Surname: last_name,
            Email: email,
            "Day of birth": rawBirthdate,
            class: classId,
            teachers: teacherIds
          } = student;

          let birthdate = rawBirthdate;
          if (
            typeof rawBirthdate === "string" ||
            typeof rawBirthdate === "number"
          ) {
            birthdate = new Date(rawBirthdate);
          }

          if (isNaN(birthdate)) {
            console.error(
              `Invalid birthdate for student ${first_name} ${last_name}: ${rawBirthdate}`
            );
            birthdate = undefined;
          } else {
            birthdate = birthdate.toISOString().split("T")[0];
          }

          const saveStudentDto = {
            userId: null,
            classId,
            teacherIds,
            first_name,
            last_name,
            birthdate,
            email
          };
          const response = await axios.post(
            `${Cloud_API_URL}/school/student`,
            saveStudentDto
          );

          if (response.data.skipped) {
            existingEmails.push(`${first_name} ${last_name} (${email})`); // Add to the existing emails list
          }
        });

      await Promise.all(signupPromises);

      if (existingEmails.length > 0) {
        alert(
          `The following students were skipped because their emails already exist:\n${existingEmails.join(
            "\n"
          )}`
        );
      } else {
        alert(
          "All students have been successfully imported and accounts created."
        );
      }

      // Fetch the updated student list
      fetchStudents(page, filterSchool, filterClass, filterTeachers);
    } catch (error) {
      console.error("There was an error creating student accounts!", error);
      alert(
        "An error occurred while creating student accounts. Please check the console for details."
      );
    }

    setLoading(false);
    handleDataClose();
  };
  const handleRemoveStudentByUUID = async studentUuid => {
    if (window.confirm("Are you sure you want to remove this student?")) {
      try {
        await axios.delete(`${Cloud_API_URL}/school/student`, {
          params: {
            studentUuid: studentUuid
          }
        });

        setImportedStudents(prevStudents =>
          prevStudents.filter(
            student => !student.user || student.user.uuid !== studentUuid
          )
        );

        console.log("Student with UUID removed successfully.");
      } catch (error) {
        console.error("Error removing student:", error);
      }
    }
  };

  const handleRemoveStudentById = async id => {
    if (window.confirm("Are you sure you want to remove this student?")) {
      try {
        await axios.delete(`${Cloud_API_URL}/school/student/by-id`, {
          params: {
            studentId: id
          }
        });

        setImportedStudents(prevStudents =>
          prevStudents.filter(student => student.id !== id)
        );
        console.log("Student with ID removed successfully.");
      } catch (error) {
        console.error("Error removing student:", error);
      }
    }
  };
  // Function to open teacher modal for a given student UUID
  const handleShowTeachers = async student => {
    try {
      // Save the student's name (assuming student has first_name and last_name properties)
      setSelectedStudentName(`${student.first_name} ${student.last_name}`);
      const data = await getTeacherInfoForStudent(student.user.uuid);
      if (data && data.teachers) {
        setSelectedStudentTeachers(data.teachers);
        setStudentTeacherDataModalOpen(true);
      } else {
        setSelectedStudentTeachers([]);
        setStudentTeacherDataModalOpen(true);
      }
    } catch (error) {
      console.error("Error retrieving teacher info for student:", error);
    }
  };

  const handleStudentTeacherDataModalClose = () => {
    setStudentTeacherDataModalOpen(false);
    setSelectedStudentTeachers([]);
  };
  return (
    <Container fluid className="main-content-container px-6">
      <div className="main-content-container">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <h6 className="m-0 font-weight-bold">Students</h6>
          <FormControlLabel
            control={
              <Switch
                checked={filterValidTill}
                onChange={handleValidTillToggle}
                color="primary"
              />
            }
            label="Show valid students"
          />
          <Box display="flex" alignItems="center">
            {(userRole === "specialTeacher" ||
              userRole === "classTeacher" ||
              userRole === "principalTeacher" ||
              userRole === "teacher") && (
              <>
                <IconButton
                  style={{ marginRight: "50px" }}
                  onClick={() => {
                    setOpenReportFrequencyModal(true);
                  }}
                >
                  <RestoreIcon />
                </IconButton>

                <Button
                  variant="contained"
                  component={RouteNavLink}
                  to={trackStudentsUrl}
                  target="_blank"
                  sx={{
                    height: "55px",
                    marginRight: "16px",
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      color: "#fff"
                    }
                  }}
                >
                  Track Students
                </Button>
              </>
            )}
            <Button
              variant="contained"
              onClick={() => {
                setIsSingleStudent(true);
                handleOpenStudentModal();
              }}
              sx={{
                height: "55px",
                marginRight: "16px"
              }}
            >
              Add Student
            </Button>
            <FormControl sx={{ minWidth: 200, marginRight: 2 }}>
              <InputLabel>Filter by School</InputLabel>
              <Select
                value={filterSchool}
                onChange={handleSchoolFilterChange}
                label="Filter by School"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {schools.map(school => (
                  <MenuItem key={school.id} value={school.id}>
                    {school.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ minWidth: 200, marginRight: 2 }}>
              <InputLabel>Filter by Class</InputLabel>
              <Select
                value={filterClass}
                onChange={handleClassFilterChange}
                label="Filter by Class"
                disabled={!filterSchool}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {filterSchool &&
                  classes[filterSchool].map(schoolClass => (
                    <MenuItem key={schoolClass.id} value={schoolClass.id}>
                      {schoolClass.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormControl
              sx={{
                minWidth: 200,
                marginRight: 2,
                height: "56px"
              }}
            >
              <Button
                variant="outlined"
                onClick={handleTeacherFilterModalOpen}
                fullWidth
                sx={{
                  height: "56px", // Set the height to match the dropdowns
                  color: "rgba(0, 0, 0, 0.87)",
                  borderColor: "rgba(0, 0, 0, 0.23)",
                  fontSize: "0.875rem",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "rgba(0, 0, 0, 0.87)", // Match the border color on hover
                    backgroundColor: "rgb(0,0,0,0)"
                  }
                }}
              >
                {filterTeachers.length > 0
                  ? `${filterTeachers.length} teacher${
                      filterTeachers.length > 1 ? "s" : ""
                    } selected`
                  : "Filter by Teachers"}
              </Button>
              {/* <InputLabel>Filter by Teachers</InputLabel>
              <Select
                multiple
                value={filterTeachers}
                onChange={handleTeacherFilterChange}
                input={<OutlinedInput label="Filter by Teachers" />}
                renderValue={selected =>
                  selected
                    .map(value => {
                      const teacher = teachers.find(t => t.id === value);
                      return teacher ? teacher.name : "";
                    })
                    .join(", ")
                }
              >
                {teachers.map(teacher => (
                  <MenuItem key={teacher.id} value={teacher.id}>
                    <Checkbox checked={filterTeachers.includes(teacher.id)} />
                    <ListItemText primary={teacher.name} />
                  </MenuItem>
                ))}
              </Select> */}
            </FormControl>
            <Modal
              open={teacherFilterModalOpen}
              onClose={handleTeacherFilterModalClose}
              aria-labelledby="modal-teacher-filter-title"
              aria-describedby="modal-teacher-filter-description"
              sx={{ overflow: "auto" }} // Ensure the modal itself is scrollable
            >
              <Box className="teacher-modal-box" sx={{ p: 2 }}>
                {/* Sticky header with title and search */}
                <Box
                  sx={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "background.paper",
                    zIndex: 1,
                    pb: 1,
                    mb: 1
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      id="modal-teacher-filter-title"
                      variant="h6"
                      component="h2"
                    >
                      Filter by Teachers
                    </Typography>
                    <IconButton onClick={handleTeacherFilterModalClose}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <TextField
                    label="Search Teacher"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={teacherSearchTerm}
                    onChange={e => setTeacherSearchTerm(e.target.value)}
                  />
                </Box>

                {/* Scrollable list */}
                <List>
                  {filteredTeachers.map(teacher => (
                    <ListItem
                      key={teacher.id}
                      button
                      onClick={() => handleTeacherFilterChange(teacher.id)}
                    >
                      <Checkbox checked={filterTeachers.includes(teacher.id)} />
                      <ListItemText primary={teacher.name} />
                    </ListItem>
                  ))}
                </List>

                {/* Sticky Done button */}
                <Box
                  sx={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "background.paper",
                    zIndex: 1,
                    pt: 1,
                    mt: 1
                  }}
                >
                  <Box display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      onClick={handleTeacherFilterModalClose}
                    >
                      Done
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Modal>
            <Button
              variant="contained"
              onClick={() => {
                handleOpen();
                setIsSingleStudent(false);
              }}
              sx={{ height: "55px" }}
            >
              Import Students
            </Button>
          </Box>
        </Box>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modal-box">
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Upload Excel File
            </Typography>
            <Input
              type="file"
              inputProps={{ accept: ".xlsx, .xls" }}
              onChange={handleFileUpload}
              fullWidth
              style={{ marginTop: "20px" }}
            />
          </Box>
        </Modal>

        <Modal
          open={dataOpen}
          onClose={handleDataClose}
          aria-labelledby="modal-data-title"
          aria-describedby="modal-data-description"
          sx={{ overflow: "hidden" }}
        >
          <Box
            className="data-modal-box"
            sx={{
              width: "70%",
              maxHeight: "85vh",
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              padding: 2
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ marginBottom: 2 }}
            >
              <Typography id="modal-data-title" variant="h6" component="h2">
                Import Students
              </Typography>
              <IconButton onClick={handleDataClose}>
                <CloseIcon />
              </IconButton>
            </Box>

            {bulkEditVisible && (
              <Box className="bulk-edit-container" sx={{ marginBottom: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={bulkEditEnabled}
                      onChange={handleBulkEditChange}
                    />
                  }
                  label="Apply to all rows"
                />
              </Box>
            )}

            <TableContainer component={Paper} sx={{ flexGrow: 1 }}>
              <Table
                stickyHeader
                sx={{ minWidth: 650 }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="caption">First Name</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption">Last Name</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption">Email</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption">Birthdate</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption">School</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption">Class</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption">Teachers</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption">Action</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {students.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography
                          variant="caption"
                          sx={{
                            textDecoration: row.deleted
                              ? "line-through"
                              : "none",
                            fontSize: "0.875rem"
                          }}
                        >
                          {row["Name"]}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="caption"
                          sx={{
                            textDecoration: row.deleted
                              ? "line-through"
                              : "none",
                            fontSize: "0.875rem"
                          }}
                        >
                          {row["Surname"]}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="caption"
                          sx={{
                            textDecoration: row.deleted
                              ? "line-through"
                              : "none",
                            fontSize: "0.875rem"
                          }}
                        >
                          {row.Email}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="caption"
                          sx={{
                            textDecoration: row.deleted
                              ? "line-through"
                              : "none",
                            fontSize: "0.875rem"
                          }}
                        >
                          {row["Day of birth"] instanceof Date
                            ? row["Day of birth"].toLocaleDateString()
                            : row["Day of birth"]}{" "}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Select
                          value={row.school}
                          onChange={handleSchoolChange(index)}
                          displayEmpty
                          fullWidth
                          disabled={row.deleted}
                          inputProps={{
                            style: {
                              fontSize: "0.875rem"
                            }
                          }}
                        >
                          <MenuItem value="">
                            <em>Select School</em>
                          </MenuItem>
                          {schools.map(school => (
                            <MenuItem key={school.id} value={school.id}>
                              {school.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                      <TableCell>
                        {row.school && classes[row.school] ? (
                          <Select
                            value={row.class}
                            onChange={handleDropdownChange(index, "class")}
                            displayEmpty
                            fullWidth
                            disabled={row.deleted}
                            inputProps={{
                              style: {
                                fontSize: "0.875rem"
                              }
                            }}
                          >
                            <MenuItem value="">
                              <em>Select Class</em>
                            </MenuItem>
                            {classes[row.school].map(schoolClass => (
                              <MenuItem
                                key={schoolClass.id}
                                value={schoolClass.id}
                              >
                                {schoolClass.name}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <Select
                            value=""
                            onChange={() => {}}
                            displayEmpty
                            fullWidth
                            disabled
                            inputProps={{
                              style: {
                                fontSize: "0.875rem"
                              }
                            }}
                          >
                            <MenuItem value="">
                              <em>Select Class</em>
                            </MenuItem>
                          </Select>
                        )}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          onClick={() => handleTeacherModalOpen(index)}
                          fullWidth
                          className="button-teachers"
                          sx={{
                            color: "rgba(0, 0, 0, 0.87)",
                            borderColor: "rgba(0, 0, 0, 0.23)",
                            fontSize: "0.675rem",
                            "&:hover": {
                              borderColor: "rgba(0, 0, 0, 0.87)",
                              backgroundColor: "rgb(0,0,0,0)"
                            }
                          }}
                          disabled={row.deleted}
                        >
                          {row.teachers && row.teachers.length > 0
                            ? `${row.teachers.length} teacher${
                                row.teachers.length > 1 ? "s" : ""
                              } selected`
                            : "Select Teachers"}
                        </Button>
                      </TableCell>

                      <TableCell>
                        {row.deleted ? (
                          <IconButton onClick={() => handleRestoreRow(index)}>
                            <RestoreIcon />
                          </IconButton>
                        ) : (
                          <IconButton onClick={() => handleDeleteRow(index)}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box className="flex-end" sx={{ marginTop: 2 }}>
              <Button
                variant="contained"
                onClick={handleFinishImport}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Finish Import"}
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={teacherModalOpen}
          onClose={handleTeacherModalClose}
          aria-labelledby="modal-teacher-title"
          aria-describedby="modal-teacher-description"
          sx={{ overflow: "auto" }}
        >
          <Box className="teacher-modal-box" sx={{ p: 2 }}>
            {/* Sticky header with title and search input */}
            <Box
              sx={{
                position: "sticky",
                top: 0,
                backgroundColor: "background.paper",
                zIndex: 1,
                pb: 1,
                mb: 1
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  id="modal-teacher-title"
                  variant="h6"
                  component="h2"
                >
                  Select Teachers
                </Typography>
                <IconButton onClick={handleTeacherModalClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <TextField
                label="Search Teacher"
                variant="outlined"
                fullWidth
                margin="normal"
                value={teacherSearchTerm}
                onChange={e => setTeacherSearchTerm(e.target.value)}
              />
            </Box>

            {/* Main list */}
            <List>
              {filteredTeachers.map(teacher => (
                <ListItem
                  key={teacher.id}
                  button
                  onClick={() =>
                    isSingleStudent
                      ? handleSingleStudentTeacherSelection(teacher.id)
                      : handleTeacherSelection(teacher.id)
                  }
                >
                  <Checkbox
                    checked={
                      isSingleStudent
                        ? studentForm.teachers.some(t =>
                            typeof t === "number"
                              ? t === teacher.id
                              : t.teacherId === teacher.id
                          )
                        : students[teacherIndex] &&
                          students[teacherIndex].teachers &&
                          students[teacherIndex].teachers.includes(teacher.id)
                    }
                  />
                  <ListItemText primary={teacher.name} />
                </ListItem>
              ))}
            </List>

            {/* Sticky footer with Done button */}
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "background.paper",
                zIndex: 1,
                pt: 1,
                mt: 1
              }}
            >
              <Box display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleTeacherModalClose}>
                  Done
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer component={Paper} className="table-container">
          <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "5%", padding: "8px" }}>
                  <Typography variant="caption">Index</Typography>
                </TableCell>
                <TableCell sx={{ width: "14%", padding: "8px" }}>
                  <Typography variant="caption">First Name</Typography>
                </TableCell>
                <TableCell sx={{ width: "14%", padding: "8px" }}>
                  <Typography variant="caption">Last Name</Typography>
                </TableCell>
                <TableCell sx={{ width: "20%", padding: "8px" }}>
                  <Typography variant="caption">Email</Typography>
                </TableCell>
                <TableCell sx={{ width: "10%", padding: "8px" }}>
                  <Typography variant="caption">School</Typography>
                </TableCell>
                <TableCell sx={{ width: "10%", padding: "8px" }}>
                  <Typography variant="caption">City</Typography>
                </TableCell>
                <TableCell sx={{ width: "10%", padding: "8px" }}>
                  <Typography variant="caption">Class</Typography>
                </TableCell>
                <TableCell sx={{ width: "10%", padding: "8px" }}>
                  <Typography variant="caption">Teachers</Typography>
                </TableCell>
                <TableCell sx={{ width: "18%", padding: "8px" }}>
                  <Typography variant="caption">Actions</Typography>
                </TableCell>
                <TableCell sx={{ width: "10%", padding: "8px" }}>
                  <Typography variant="caption">Delete</Typography>
                </TableCell>
                <TableCell sx={{ width: "10%", padding: "8px" }}>
                  <Typography variant="caption">Edit</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStudents.length > 0 &&
                filteredStudents.map((student, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ padding: "8px" }}>
                      {console.log(student)}
                      <Typography
                        variant="caption"
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {(page - 1) * 50 + index + 1}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <Typography
                        variant="caption"
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {student.first_name}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <Typography
                        variant="caption"
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {student.last_name}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <Typography
                        variant="caption"
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {student.email}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <Typography
                        variant="caption"
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {(student &&
                          student.class &&
                          student.class.school &&
                          student.class.school.name) ||
                          student.Class}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <Typography
                        variant="caption"
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {(student &&
                          student.class &&
                          student.class.school &&
                          student.class.school.city) ||
                          student.City}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <Typography
                        variant="caption"
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {student.class.name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {student.userId ? (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleShowTeachers(student)}
                        >
                          Show Teachers
                        </Button>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      {student.userId ? (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleShowDetails(student.user.uuid)}
                        >
                          Show Details
                        </Button>
                      ) : (
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.875rem",
                            fontFamily: "Times New Roman, Times, serif"
                          }}
                        >
                          {student.purchase && student.purchase.code
                            ? student.purchase.code
                            : ""}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      {student.userId ? (
                        // If userId is present, handle UUID-based deletion (Firebase + SQL)
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() =>
                            handleRemoveStudentByUUID(student.user.uuid)
                          }
                        >
                          Remove
                        </Button>
                      ) : (
                        // If userId is not present (unactivated account), handle ID-based deletion (SQL only)
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => handleRemoveStudentById(student.id)}
                        >
                          Remove
                        </Button>
                      )}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setIsSingleStudent(true);
                          handleOpenStudentModal(student);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <Pagination
            count={Math.ceil(totalCount / 50)}
            page={page}
            onChange={handlePageChange}
            sx={{
              display: "flex",
              justifyContent: "center",
              margin: "20px 0"
            }}
          />
        </TableContainer>

        <Modal
          open={openReportFrequencyModal}
          onClose={() => {
            setOpenReportFrequencyModal(false);
          }}
        >
          <Box
            className="modal-box"
            sx={{
              maxWidth: "250px",
              maxHeight: "90vh",
              overflow: "auto"
            }}
          >
            <FormControl sx={{ minWidth: 200, marginRight: 2 }}>
              <InputLabel>Report Frequency</InputLabel>
              <Select
                value={reportFrequency}
                onChange={handleReportFrequencyChange}
                label="Report frequency"
              >
                {reportFrequencies.map(reportFrequency => (
                  <MenuItem
                    key={reportFrequency.value}
                    value={reportFrequency.value}
                  >
                    {reportFrequency.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Modal>
        {/* Modal to display teacher details for a student */}
        <Modal
          open={studentTeacherDataModalOpen}
          onClose={handleStudentTeacherDataModalClose}
          aria-labelledby="teacher-modal-title"
          aria-describedby="teacher-modal-description"
          sx={{ overflow: "auto" }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              position: "relative"
            }}
          >
            <Typography
              id="teacher-modal-title"
              variant="h6"
              component="h2"
              sx={{ fontSize: "1.2rem", mb: 2 }}
            >
              Teachers for {selectedStudentName}
            </Typography>
            <IconButton
              onClick={handleStudentTeacherDataModalClose}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
            {selectedStudentTeachers.length > 0 ? (
              selectedStudentTeachers.map((teacher, idx) => (
                <Box key={idx} sx={{ mb: 1 }}>
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    <Link
                      href={`/sub-admin-data/${teacher.teacher_uuid}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textDecoration: "none",
                        color: "inherit",
                        "&:hover": { textDecoration: "underline" }
                      }}
                    >
                      {teacher.firstName} {teacher.lastName}
                    </Link>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {teacher.email}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography>No teachers found.</Typography>
            )}
          </Box>
        </Modal>

        <Modal open={studentModalOpen} onClose={handleCloseStudentModal}>
          <Box
            className="modal-box"
            sx={{
              maxWidth: "600px",
              maxHeight: "90vh",
              overflow: "auto"
            }}
          >
            <Typography variant="h6">
              {editingStudent ? "Edit Student" : "Add Student"}
            </Typography>
            <TextField
              label="First Name"
              value={studentForm.first_name}
              onChange={e => handleFormChange("first_name", e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Last Name"
              value={studentForm.last_name}
              onChange={e => handleFormChange("last_name", e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Email"
              value={studentForm.email}
              onChange={e => handleFormChange("email", e.target.value)}
              fullWidth
              margin="normal"
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Birthdate"
                value={selectedDate}
                onChange={newValue => handleDateChange(newValue)}
                slotProps={{ textField: { fullWidth: true } }}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    margin="normal"
                    sx={{ width: "100%" }}
                  />
                )}
              />
            </LocalizationProvider>

            <FormControl fullWidth margin="normal">
              <InputLabel>School</InputLabel>
              <Select
                value={studentForm.school}
                onChange={e => handleFormChange("school", e.target.value)}
              >
                {schools.map(school => (
                  <MenuItem key={school.id} value={school.id}>
                    {school.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Class</InputLabel>
              <Select
                value={studentForm.class}
                onChange={e => handleFormChange("class", e.target.value)}
                disabled={!studentForm.school}
              >
                {studentForm.school &&
                  classes[studentForm.school] &&
                  classes[studentForm.school].map(schoolClass => (
                    <MenuItem key={schoolClass.id} value={schoolClass.id}>
                      {schoolClass.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <Button
              variant="outlined"
              onClick={handleTeacherModalOpen}
              fullWidth
              sx={{
                marginTop: 2,
                color: "rgba(0, 0, 0, 0.87)",
                borderColor: "rgba(0, 0, 0, 0.23)",
                fontSize: "0.675rem",
                "&:hover": {
                  borderColor: "rgba(0, 0, 0, 0.87)",
                  backgroundColor: "rgb(0,0,0,0)"
                }
              }}
            >
              {studentForm.teachers.length > 0
                ? `${studentForm.teachers.length} teacher${
                    studentForm.teachers.length > 1 ? "s" : ""
                  } selected`
                : "Select Teachers"}
            </Button>

            <Box display="flex" justifyContent="flex-end" sx={{ marginTop: 2 }}>
              <Button variant="contained" onClick={handleSaveStudent}>
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
      </Paper>
    </Container>
  );
};

export default Students;
